import axios from 'axios';
// const ROOT_API = process.env.VUE_APP_ROOT_API;
const baseDomain = "";
const url = `${baseDomain}`;
axios.defaults.baseURL = url;
const isHandlerEnabled = (config={}) => {
    return !(config.hasOwnProperty('handlerEnabled') && !config.handlerEnabled)
};

const errorHandler = (error) => {
    if (isHandlerEnabled(error.config)) {
        if (process.env.NODE_ENV !== 'production'){console.error(error);}
        // Handle errors
    }
    return Promise.reject({ ...error })
};

const successHandler = (response) => {
    if (isHandlerEnabled(response.config)) {

        // Handle responses
    }
    return response
};

const instanceThemes = axios.create();

instanceThemes.interceptors.response.use(
    response => successHandler(response),
    error => errorHandler(error)
);


export default instanceThemes